import { render, staticRenderFns } from "./RQBSB.vue?vue&type=template&id=7284ba20&scoped=true&"
import script from "./RQBSB.vue?vue&type=script&lang=js&"
export * from "./RQBSB.vue?vue&type=script&lang=js&"
import style0 from "./RQBSB.vue?vue&type=style&index=0&id=7284ba20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284ba20",
  null
  
)

export default component.exports